import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppCard, AppCardContent, AppCardFooter } from "../Generic/AppCard";
import AppSlideFadeIn from "../Generic/AppSlideFadeIn";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";

type Props = {
  onClickGoBack: () => void;
};

export default function RaffleInfoScreen(props: Props) {
  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.HOW_DOES_IT_WORK)} />}
      onClickGoBack={props.onClickGoBack}
    >
      <Steps>
        <Step
          title={translate(STRINGS.RAFFLE_INFO_1_TITLE)}
          description={translate(STRINGS.RAFFLE_INFO_1_DESCRIPTION)}
        />

        <Step
          title={translate(STRINGS.RAFFLE_INFO_2_TITLE)}
          description={translate(STRINGS.RAFFLE_INFO_2_DESCRIPTION)}
          animationDelay={100}
        />

        <Step
          title={translate(STRINGS.RAFFLE_INFO_3_TITLE)}
          description={translate(STRINGS.RAFFLE_INFO_3_DESCRIPTION)}
          animationDelay={200}
        />

        <Step
          title={translate(STRINGS.RAFFLE_INFO_4_TITLE)}
          description={translate(STRINGS.RAFFLE_INFO_4_DESCRIPTION)}
          animationDelay={300}
        />
      </Steps>
    </Scaffold>
  );
}

const Step = (props: {
  title: string;
  description: string;
  imgSrc?: string;
  animationDelay?: number;
  footer?: React.ReactNode;
}) => {
  return (
    <AppSlideFadeIn delay={props.animationDelay}>
      <StepCard>
        <AppCardContent>
          <StepRoot>
            <StepContent>
              <StepTitle>{props.title}</StepTitle>
              <StepDescription>{props.description}</StepDescription>
            </StepContent>
          </StepRoot>
        </AppCardContent>
        {Boolean(props.footer) && <AppCardFooter>{props.footer}</AppCardFooter>}
      </StepCard>
    </AppSlideFadeIn>
  );
};

const StepContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`;

const StepTitle = styled.h3`
  font-size: 16px;
  margin: 0;
`;

const StepDescription = styled.p`
  font-size: 14px;
  color: var(--tw-slate-600);
  margin: 0;
`;

const StepCard = styled(AppCard)``;

const StepRoot = styled.div`
  display: flex;
  gap: 16px;
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 20px;
`;
